<template>
	<v-card flat class="mt-4">
		<v-row no-gutters align="center">
			<h6 class="text-body-1 font-weight-bold mr-4">{{ requirement.requirement_type.name }}</h6>
			<v-btn
				color="secondary"
				small
				@click="
					$router.push({
						name: 'requirement_index',
						params: { id: requirement.id },
						query: {
							department_id: $store.getters['auth/authData'].user_departments[0].id,
						},
					})
				"
			>
				<v-icon small class="mr-1">mdi-tab-plus</v-icon>
				依頼を確認する
			</v-btn>
		</v-row>
		<v-tabs v-model="tab" height="36px" slider-color="primary" color="black">
			<v-tab class="text-body-2" v-for="(item, i) in tabs" :key="i">
				{{ item.name }}
			</v-tab>
		</v-tabs>
		<v-sheet elevation="0">
			<v-tabs-items v-model="tab" class="pa-2">
				<v-tab-item>
					<table width="100%" class="show-dialog-table">
						<tbody>
							<ShowDetailRecord :columnName="'サブタイトル'" :value="requirement.subtitle" />
							<ShowDetailRecord :columnName="'状態'" :value="requirement.status_id_i18n" />
							<ShowDetailRecord
								:columnName="'依頼発行日'"
								:value="common.formatDate(requirement.requirement_date)"
							/>
							<ShowDetailRecord
								:columnName="'希望納期'"
								:value="common.formatDate(requirement.deadline)"
							/>
							<ShowDetailRecord
								:columnName="'依頼元部門'"
								:value="
									$store.getters.department(requirement.from_department_id)
										? $store.getters.department(requirement.from_department_id).name
										: ''
								"
							/>
							<ShowDetailRecord :columnName="'依頼者'" :value="requirement.user.full_name" />
							<template v-if="showRequirementDetail">
								<ShowDetailRecord
									v-if="requirement.requirement_type.confirmation_flag"
									:columnName="'確認者'"
								>
									<template v-slot:value>
										<p
											class="no-wrap"
											v-for="confirmation in requirement.confirmations"
											:key="'confirmation-' + confirmation.id"
										>
											{{ confirmation.user.full_name }}
											<span class="fs0875">{{ common.formatDate(confirmation.created_at) }}</span>
										</p>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord
									v-if="requirement.requirement_type.approval_flag"
									:columnName="'承認者'"
								>
									<template v-slot:value>
										<p
											class="no-wrap"
											v-for="approval in requirement.approvals"
											:key="'approval-' + approval.id"
										>
											{{ approval.user.full_name }}
											<span class="fs0875">{{ common.formatDate(approval.created_at) }}</span>
										</p>
									</template>
								</ShowDetailRecord>

								<ShowDetailRecord
									:columnName="'依頼先部門'"
									:value="
										$store.getters.department(requirement.to_department_id)
											? $store.getters.department(requirement.to_department_id).name
											: ''
									"
								/>
								<ShowDetailRecord
									:columnName="'担当者'"
									:value="requirement.responder != null ? requirement.responder.full_name : '未定'"
								/>

								<ShowDetailRecord
									v-if="requirement.requirement_type.need_matter_flag"
									:columnName="'案件'"
									:value="common.returnMatterInfo(requirement.matter)"
									text
								/>
								<ShowDetailRecord
									v-if="
										requirement.requirement_type.need_matter_flag && !requirement.matter.contract
									"
									:columnName="'見積製品（対象絞り込み）'"
									:value="common.matterProductByRequirement(requirement)"
									text
								/>
								<ShowDetailRecord
									v-if="
										requirement.requirement_type.need_matter_flag && requirement.matter.contract
									"
									:columnName="'受注製品（製番）'"
									:value="common.orderedProductByRequirement(requirement)"
									text
								/>
								<ShowDetailRecord
									v-if="requirement.requirement_type.need_matter_flag"
									:columnName="
										requirement.matter.contract ? '受注製品（枝番）' : '見積製品（枝番）'
									"
									:value="common.orderIndividualInfoByRequirement(requirement)"
									text
								/>
								<ShowDetailRecord
									v-for="column in requirement.requirement_type.requirement_columns"
									:key="column.id"
									:columnName="column.name"
									:value="
										column.data_type != 'file'
											? common.value(column, lodashGet(valueByRequirementColumn(column), 'value'))
											: ''
									"
									:text="column.data_type == 'text'"
								>
									<template v-if="column.data_type == 'file'" v-slot:value>
										<template
											v-if="
												checkFileExist(
													lodashGet(valueByRequirementColumn(column), 'attached_files')
												)
											"
										>
											<p
												v-for="(file, i) in lodashGet(
													valueByRequirementColumn(column),
													'attached_files'
												)"
												class="text-body-2"
												:key="i"
											>
												{{ file.name }}
											</p>
										</template>
										<template v-else> アップロードされたファイルはありません。 </template>
									</template>
								</ShowDetailRecord>
								<ShowDetailRecord :columnName="'伝達事項'" :value="requirement.message" text />
							</template>
							<template>
								<tr>
									<td colspan="2" class="pa-0">
										<v-btn
											@click="showRequirementDetail = !showRequirementDetail"
											width="100%"
											height="28px"
											text
										>
											<span v-if="showRequirementDetail">詳細を隠す</span>
											<span v-else>詳細を表示</span>
										</v-btn>
									</td>
								</tr>
							</template>
						</tbody>
					</table>
				</v-tab-item>

				<v-tab-item>
					<table
						v-if="
							requirement.answer &&
							requirement.answer.status_id != 'draft' &&
							requirement.answer.status_id != 'refused'
						"
						width="100%"
						class="show-dialog-table"
					>
						<tbody>
							<ShowDetailRecord
								:columnName="'回答名'"
								:value="requirement.answer.answer_template.name"
							/>
							<ShowDetailRecord :columnName="'状態'" :value="requirement.answer.status_id_i18n" />
							<ShowDetailRecord
								:columnName="'回答日'"
								:value="common.formatDate(requirement.answer.answer_date)"
							/>
							<ShowDetailRecord
								:columnName="'依頼元部門'"
								:value="
									$store.getters.department(requirement.from_department_id)
										? $store.getters.department(requirement.from_department_id).name
										: ''
								"
							/>
							<ShowDetailRecord :columnName="'依頼者'" :value="requirement.user.full_name" />
							<ShowDetailRecord
								:columnName="'回答部門'"
								:value="
									$store.getters.department(requirement.to_department_id)
										? $store.getters.department(requirement.to_department_id).name
										: ''
								"
							/>
							<ShowDetailRecord
								:columnName="'担当者'"
								:value="requirement.responder != null ? requirement.responder.full_name : '未定'"
							/>
							<ShowDetailRecord
								v-if="requirement.answer.answer_template.need_check_flag"
								:columnName="'確認者'"
							>
								<template v-slot:value>
									<p
										class="no-wrap"
										v-for="confirmation in requirement.answer.confirmations"
										:key="'confirmation-' + confirmation.id"
									>
										{{ confirmation.user.full_name }}
										<span class="fs0875">{{ common.formatDate(confirmation.created_at) }}</span>
									</p>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord
								v-if="requirement.answer.answer_template.need_approval_flag"
								:columnName="'承認者'"
							>
								<template v-slot:value>
									<p
										class="no-wrap"
										v-for="approval in requirement.answer.approvals"
										:key="'approval-' + approval.id"
									>
										{{ approval.user.full_name }}
										<span class="fs0875">{{ common.formatDate(approval.created_at) }}</span>
									</p>
								</template>
							</ShowDetailRecord>
							<ShowDetailRecord :columnName="'伝達事項'" :value="requirement.answer.message" text />
							<template v-if="showAnswerDetail">
								<ShowDetailRecord
									v-for="column in requirement.answer.answer_template.answer_columns"
									:key="column.id"
									:columnName="column.name"
									:value="
										column.data_type != 'file'
											? common.value(column, lodashGet(valueByAnswerColumn(column), 'value'))
											: null
									"
									:text="column.data_type == 'text'"
								>
									<template v-if="column.data_type == 'file'" v-slot:value>
										<template
											v-if="
												checkFileExist(
													lodashGet(valueByRequirementColumn(column), 'attached_files')
												)
											"
										>
											<p
												v-for="(file, i) in lodashGet(
													valueByRequirementColumn(column),
													'attached_files'
												)"
												class="text-body-2"
												:key="i"
											>
												{{ file.name }}
											</p>
										</template>
										<template v-else> アップロードされたファイルはありません。 </template>
									</template>
								</ShowDetailRecord>
							</template>
							<tr>
								<td colspan="2" class="pa-0">
									<v-btn
										@click="showAnswerDetail = !showAnswerDetail"
										width="100%"
										height="28px"
										text
									>
										<span v-if="showAnswerDetail">詳細を隠す</span>
										<span v-else>詳細を表示</span>
									</v-btn>
								</td>
							</tr>
						</tbody>
					</table>
					<v-sheet elevation="0" class="pa-2" v-else>
						<p class="align-center text-body-2">回答はまだ作成されていません。</p>
					</v-sheet>
				</v-tab-item>
			</v-tabs-items></v-sheet
		>
	</v-card>
</template>

<script>
import lodashGet from "lodash/get" // templateのオプショナルチェーン用
import common from "../../helper/common"
import ShowDetailRecord from "./ShowDetailRecord.vue"

export default {
	props: {
		requirement: {
			type: Object,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {
			common,
			lodashGet,
			showRequirementDetail: false,
			showAnswerDetail: false,
			tab: 0,
			tabs: [{ name: "依頼" }, { name: "回答" }],
		}
	},
	methods: {
		diffDate(deadline) {
			let today = moment(new Date())
			let gap = moment(deadline).diff(today, "days")
			if (gap <= 5) {
				return true
			} else {
				return false
			}
		},
		openFilesDialog(value) {
			this.$refs.files.openDialog(value.id)
		},
		setFiles(files, id) {
			const value = this.requirement.requirement_values.find((v) => v.id == id)
			if (!value) return
			const index = this.requirement.requirement_values.indexOf(value)
			this.requirement.requirement_values[index].attached_files = files
		},
		valueByRequirementColumn(column) {
			return this.requirement.requirement_values.find((v) => v.requirement_column_id == column.id)
		},
		valueByAnswerColumn(column) {
			return this.requirement.answer.answer_values.find((v) => v.answer_column_id == column.id)
		},
	},
	computed: {
		checkFileExist() {
			return (attachedFiles) => {
				if (attachedFiles == null || attachedFiles == []) return false
				return attachedFiles.filter((file) => !file.destroy_flag).length > 0
			}
		},
	},
}
</script>

<style lang="scss" scoped>
</style>